import { CartItem } from '../../../../types/common';
import { formatPrice } from '../../../../utils/helpers';
import classes from './OrderCartItem.module.css';

interface IOrderCartItemProps {
    name: CartItem['name'];
    quantity: CartItem['quantity'];
    stockQuantity?: CartItem['stockQuantity'];
    price: CartItem['price'];
    discount: CartItem['discount'];
    discountedPrice: CartItem['discountedPrice'];
    specialDiscountedPrice: CartItem['specialDiscountedPrice'];
    specialDiscountPercent: CartItem['specialDiscountPercent'];
    // totalPrice: CartItem['totalPrice'];
    idx: number;
    birthdayDiscount: boolean;
    hasPromo: boolean;
    articleNumber?: string;
    promoPercent: number | null;
    sizeOrColor?: string;
    threePlusApplied?: boolean;
}

const OrderCartItem: React.FC<IOrderCartItemProps> = ({
    name,
    quantity,
    stockQuantity,
    price,
    discount,
    discountedPrice,
    specialDiscountedPrice,
    specialDiscountPercent,
    // totalPrice,
    idx,
    birthdayDiscount,
    hasPromo,
    articleNumber,
    promoPercent,
    sizeOrColor,
    threePlusApplied,
}) => {
    const stockDisplay = stockQuantity === undefined ? NaN : stockQuantity;
    const round2 = (n: number): number => Math.round(n * 100) / 100;
    const applyPercent = (base: number, percent: number): number => round2(base * (1 - percent / 100));
    const clampPercent = (v: number): number => (v < 0 ? 0 : v > 100 ? 100 : round2(v));
    const isNum = (v: unknown): v is number => typeof v === 'number' && Number.isFinite(v);
    const showBirthday = birthdayDiscount;
    const showPromo = !showBirthday && hasPromo && discountedPrice != null;
    const showSpecial = !showBirthday && !showPromo && specialDiscountedPrice != null;
    const isThreePlus = threePlusApplied === true;
    const showThreePlus = !showBirthday && !showPromo && !showSpecial && isThreePlus;
    const showRegular = !showBirthday && !showPromo && !showSpecial && !showThreePlus && discountedPrice != null;
    // const unitDisplayPrice = showBirthday
    //     ? +(price * 0.75).toFixed(2)
    //     : showPromo
    //     ? discountedPrice!
    //     : showSpecial
    //     ? specialDiscountedPrice!
    //     : showRegular
    //     ? discountedPrice!
    //     : price;

    const unitPrice = isNum(price) ? price : 0;
    let baseBeforePromo = unitPrice;
    if (!showBirthday) {
        if (isNum(specialDiscountedPrice)) {
            baseBeforePromo = round2(specialDiscountedPrice);
        } else if (isNum(specialDiscountPercent) && specialDiscountPercent > 0) {
            baseBeforePromo = applyPercent(unitPrice, clampPercent(specialDiscountPercent));
        } else if (isNum(discountedPrice)) {
            baseBeforePromo = round2(discountedPrice);
        } else if (isNum(discount) && discount > 0) {
            baseBeforePromo = applyPercent(unitPrice, clampPercent(discount));
        }
    }
    const threePlusPercent = showThreePlus && isNum(discountedPrice) && unitPrice > 0 ? clampPercent(((unitPrice - discountedPrice) / unitPrice) * 100) : null;
    const promoOk = !showBirthday && hasPromo && isNum(promoPercent) && promoPercent > 0;
    const effectivePromo = promoOk ? clampPercent(promoPercent as number) : null;
    const unitForTotals = showBirthday ? round2(unitPrice * 0.75) : effectivePromo != null ? applyPercent(baseBeforePromo, effectivePromo) : baseBeforePromo;

    const lineTotalPrice = round2(unitForTotals * quantity);

    return (
        <tr className={classes['orderTable__body_row']}>
            <td className={classes['orderTable__body_row_elem']}>{idx}</td>
            <td className={classes['orderTable__body_row_elem']}>{name}</td>
            <td className={classes['orderTable__body_row_elem']}>{articleNumber?.trim() ? articleNumber : '—'}</td>
            <td className={classes['orderTable__body_row_elem']}>{sizeOrColor?.trim() || '-'}</td>
            <td style={{ textAlign: 'center', cursor: 'default' }} className={classes['orderTable__body_row_elem']} title="Единиц заказано">
                {quantity}
            </td>
            <td
                style={{ textAlign: 'center', cursor: 'default', color: quantity > stockDisplay ? 'red' : 'inherit' }}
                className={classes['orderTable__body_row_elem']}
                title="Единиц доступно со склада"
            >
                {!Number.isNaN(stockDisplay) ? stockDisplay : '-'}
            </td>
            <td
                className={classes['orderTable__body_row_elem']}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <span>{formatPrice(unitForTotals)} ₽</span>
                {(showBirthday || showPromo || showSpecial || showRegular || showThreePlus || promoOk) && (
                    <span
                        style={{
                            fontSize: '12px',
                            color: showBirthday ? 'green' : 'red',
                            cursor: 'default',
                        }}
                        title={`от ${formatPrice(price)} ₽`}
                    >
                        {showBirthday && `–25 % (ДР)`}
                        {showPromo && `–${discount} % (промо)`}
                        {showSpecial && `–${specialDiscountPercent ?? 0} % (спец)`}
                        {showRegular && `–${discount} %`}
                        {showThreePlus && threePlusPercent != null && `–${threePlusPercent} % (3+ товара)`}
                        {promoOk && `–${effectivePromo}% (промо)`}
                    </span>
                )}
            </td>
            <td className={`${classes['orderTable__body_row_elem']} ${classes['cell']}`}>
                {birthdayDiscount ? (
                    <>
                        <span>{formatPrice(price * 0.75)} ₽</span>
                        <span style={{ fontSize: '12px', color: 'green' }}>–25 % от {formatPrice(price)} ₽</span>
                    </>
                ) : (
                    <span>{formatPrice(lineTotalPrice)} ₽</span>
                )}
            </td>
        </tr>
    );
};

export default OrderCartItem;
